import { ReactNode } from 'react';
import { Grid } from '@optimus-web/core';

interface AccountingCategoryGridProps {
    children: ReactNode;
}

export const AccountingCategoryGrid = ({ children }: AccountingCategoryGridProps) => (
    <Grid
        columnGap="200"
        templateRows="repeat(auto-fit, minmax(0, 2fr), minmax(0, 2fr))"
        templateColumns="minmax(0, 2fr) minmax(0, 2fr)"
        height="100%"
        tabletOnly={{
            templateColumns: 'minmax(0, 4fr)',
        }}
        largePhoneOnly={{
            templateColumns: 'minmax(0, 2fr)',
        }}
        phoneOnly={{
            templateColumns: 'minmax(0, 1fr)',
        }}
    >
        {children}
    </Grid>
);
